import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../_services/admin.service';
import { Threshold } from '../../_models/threshold';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';

@Component({
  selector: 'app-set-threshold',
  templateUrl: './set-threshold.component.html',
  styleUrls: ['./set-threshold.component.css']
})
export class SetThresholdComponent implements OnInit {
  threshold!: number;
  thresholdModel: Threshold = new Threshold;
  thresholdList!: Threshold[];
  constructor(
    private adminService  : AdminService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.GetThreshold();
  }
  
  GetThreshold(){
    this.adminService.ViewMstThreshold().subscribe((res: Threshold[]) => {
      this.thresholdList =res;
      this.threshold=this.thresholdList.filter(t=>t.ToDateFormatted?.trim() == '')[0].Threshold_Amount;
    });
  }

  OnSubmit(){
    this.thresholdModel = {
      Id:0,
      Threshold_Amount : this.threshold,
      CurrencyCode : 'USD',
      FromDate : new Date(),
      UpdatedDate:new Date(),
    }
    this.adminService.AddThreshold(this.thresholdModel).subscribe((res: any) => {
         this.GetThreshold();
         this.openAlertModal("Record Saved Successfully");
    });
  }

  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }
}
